import { Logger } from '@wix/wix-log';

export const beLogger = new Logger('price-quotes-server');
